import { get, patch, post } from '../../utils/http';

export const createInvoiceForAllClients = ({
  accountId,
  fromDate,
  toDate,
  groupBy,
  isSweepBackEnabled = false,
  splitInvoicesIntoWeeks = true,
  isAttachmentsOnly = false,
  isMergeAllClients = false
}) =>
  post(`/accounts/${accountId}/invoices`, {
    fromDate,
    toDate,
    groupBy,
    isSweepBackEnabled,
    splitInvoicesIntoWeeks,
    isAttachmentsOnly,
    isMergeAllClients
  });

export const getInvoiceAttachment = ({
  accountId,
  integrationInvoiceId,
  integrationAttachmentId,
  attachmentMimeType
}) =>
  post(
    `/accounts/${accountId}/invoices/${integrationInvoiceId}/attachments/${integrationAttachmentId}`,
    {
      attachmentMimeType
    },
    { responseType: 'blob' }
  );

export const cancelInvoice = ({ accountId, invoiceId }) => patch(`/accounts/${accountId}/invoices/${invoiceId}/cancel`);

/*
type filters = {
	clientsIds: number[];
	status: string;
	fromDate: Date;
	toDate: Date;
};
 */

export const getInvoiceAsPdf = ({ accountId, invoiceId }) =>
  get(`/accounts/${accountId}/invoices/${invoiceId}/pdf`, {}, { responseType: 'blob' });

export const getInvoiceSnapshot = ({ accountId, invoiceId, tab }) =>
  get(`/accounts/${accountId}/invoices/${tab}/${invoiceId}`);

export const getIssuedInvoices = ({ accountId, filters }) =>
  post(`/accounts/${accountId}/invoices/issued`, { filters });

/*
type filters = {
	status: string;
	fromDate: Date;
	toDate: Date;
};
 */

export const getReceivedInvoices = ({ accountId, filters }) =>
  post(`/accounts/${accountId}/invoices/received`, { filters });
